<template>
<div id="detectionfamily">
    <div class="container">
        <div class="row" >
            <div class="col-sm-12">
                <form action="" method="post">
                    <h2>親情</h2>
                    <div class="form-block">
                        <div v-show="step === 1" id="form_part1">
                            <div class="container">
                                <p>即將畢業的你，滿心期待可以脫離學生身份、出社會工作，這時家長卻對你說：「我已經幫你準備好錢了，你趕緊讀書、準備研究所的考試。我不管你要考什麼，只要能拿一個學位回來就好。」可是，你已經有了自己的規劃、想好要去哪工作，也去過相關單位實習了。當你嘗試跟家長溝通時，他們又說：「不要想著你想先工作，大學剛畢業你能做什麼？沒混到好一點、高一點的文憑，你能做什麼？掃地工嗎？」</p>
                            </div>
                            <ul>
                                <li class="question">	
                                    <h5>1.我應該要達到家長的期望。</h5>
                                    <ul class="option">
                                        <li class="answer">
                                            <input type='radio' value='11' class='q1' id='q11' name="q1" v-model='q1'>
                                            <label for='q11'>總是</label>
                                        </li>
                                        <li class="answer">
                                            <input type='radio' value='8' class='q2' id='q12' name="q1" v-model='q1'>
                                            <label for='q12'>經常</label>
                                        </li>
                                        <li class="answer">
                                            <input type='radio' value='5' class='q3' id='q13' name="q1" v-model='q1'>
                                            <label for='q13'>偶爾</label>
                                        </li>
                                        <li class="answer">
                                            <input type='radio' value='2' class='q4' id='q14' name="q1" v-model='q1'>
                                            <label for='q14'>很少</label>
                                        </li>
                                        <li class="answer">
                                            <input type='radio' value='0' class='q5' id='q15' name="q1" v-model='q1'>
                                            <label for='q15'>從不</label>
                                        </li>
                                    </ul>
                                </li>
                                <li class="question">	
                                    <h5>2.我害怕和家長溝通會吵起來。</h5>
                                    <ul class="option">
                                        <li class="answer">
                                            <input type='radio' value='11' class='q1' id='q21' name="q2" v-model='q2'>
                                            <label for='q21'>總是</label>
                                        </li>
                                        <li class="answer">
                                            <input type='radio' value='8' class='q2' id='q22' name="q2" v-model='q2'>
                                            <label for='q22'>經常</label>
                                        </li>
                                        <li class="answer">
                                            <input type='radio' value='5' class='q3' id='q23' name="q2" v-model='q2'>
                                            <label for='q23'>偶爾</label>
                                        </li>
                                        <li class="answer">
                                            <input type='radio' value='2' class='q4' id='q24' name="q2" v-model='q2'>
                                            <label for='q24'>很少</label>
                                        </li>
                                        <li class="answer">
                                            <input type='radio' value='0' class='q5' id='q25' name="q2" v-model='q2'>
                                            <label for='q25'>從不</label>
                                        </li>
                                    </ul>
                                </li>
                                <li class="question">	
                                    <h5>3.我害怕不順從，家長就會不喜歡我。</h5>
                                    <ul class="option">
                                        <li class="answer">
                                            <input type='radio' value='11' class='q1' id='q31' name="q3" v-model='q3'>
                                            <label for='q31'>總是</label>
                                        </li>
                                        <li class="answer">
                                            <input type='radio' value='8' class='q2' id='q32' name="q3" v-model='q3'>
                                            <label for='q32'>經常</label>
                                        </li>
                                        <li class="answer">
                                            <input type='radio' value='5' class='q3' id='q33' name="q3" v-model='q3'>
                                            <label for='q33'>偶爾</label>
                                        </li>
                                        <li class="answer">
                                            <input type='radio' value='2' class='q4' id='q34' name="q3" v-model='q3'>
                                            <label for='q34'>很少</label>
                                        </li>
                                        <li class="answer">
                                            <input type='radio' value='0' class='q5' id='q35' name="q3" v-model='q3'>
                                            <label for='q35'>從不</label>
                                        </li>
                                    </ul>
                                </li>
                                <li class="question">	
                                    <h5>4.我會因為不想讓父母動怒而疲於爭論。</h5>
                                    <ul class="option">
                                        <li class="answer">
                                            <input type='radio' value='11' class='q1' id='q41' name="q4" v-model='q4'>
                                            <label for='q41'>總是</label>
                                        </li>
                                        <li class="answer">
                                            <input type='radio' value='8' class='q2' id='q42' name="q4" v-model='q4'>
                                            <label for='q42'>經常</label>
                                        </li>
                                        <li class="answer">
                                            <input type='radio' value='5' class='q3' id='q43' name="q4" v-model='q4'>
                                            <label for='q43'>偶爾</label>
                                        </li>
                                        <li class="answer">
                                            <input type='radio' value='2' class='q4' id='q44' name="q4" v-model='q4'>
                                            <label for='q44'>很少</label>
                                        </li>
                                        <li class="answer">
                                            <input type='radio' value='0' class='q5' id='q45' name="q4" v-model='q4'>
                                            <label for='q45'>從不</label>
                                        </li>
                                    </ul>
                                </li>
                                <li class="question">	
                                    <h5>5.家長是為了我著想，我不應該忤逆他們。</h5>
                                    <ul class="option">
                                        <li class="answer">
                                            <input type='radio' value='11' class='q1' id='q51' name="q5" v-model='q5'>
                                            <label for='q51'>總是</label>
                                        </li>
                                        <li class="answer">
                                            <input type='radio' value='8' class='q2' id='q52' name="q5" v-model='q5'>
                                            <label for='q52'>經常</label>
                                        </li>
                                        <li class="answer">
                                            <input type='radio' value='5' class='q3' id='q53' name="q5" v-model='q5'>
                                            <label for='q53'>偶爾</label>
                                        </li>
                                        <li class="answer">
                                            <input type='radio' value='2' class='q4' id='q54' name="q5" v-model='q5'>
                                            <label for='q54'>很少</label>
                                        </li>
                                        <li class="answer">
                                            <input type='radio' value='0' class='q5' id='q55' name="q5" v-model='q5'>
                                            <label for='q55'>從不</label>
                                        </li>
                                    </ul>
                                </li>
                                <li class="question">	
                                    <h5>6.如果不遵照家長的期望，我會感到愧疚。</h5>
                                    <ul class="option">
                                        <li class="answer">
                                            <input type='radio' value='11' class='q1' id='q61' name="q6" v-model='q6'>
                                            <label for='q61'>總是</label>
                                        </li>
                                        <li class="answer">
                                            <input type='radio' value='8' class='q2' id='q62' name="q6" v-model='q6'>
                                            <label for='q62'>經常</label>
                                        </li>
                                        <li class="answer">
                                            <input type='radio' value='5' class='q3' id='q63' name="q6" v-model='q6'>
                                            <label for='q63'>偶爾</label>
                                        </li>
                                        <li class="answer">
                                            <input type='radio' value='2' class='q4' id='q64' name="q6" v-model='q6'>
                                            <label for='q64'>很少</label>
                                        </li>
                                        <li class="answer">
                                            <input type='radio' value='0' class='q5' id='q65' name="q6" v-model='q6'>
                                            <label for='q65'>從不</label>
                                        </li>
                                    </ul>
                                </li>
                                <li class="question">	
                                    <h5>7.我擔心因為我的拒絕而破壞和家長之間的感情。</h5>
                                    <ul class="option">
                                        <li class="answer">
                                            <input type='radio' value='11' class='q1' id='q71' name="q7" v-model='q7'>
                                            <label for='q71'>總是</label>
                                        </li>
                                        <li class="answer">
                                            <input type='radio' value='8' class='q2' id='q72' name="q7" v-model='q7'>
                                            <label for='q72'>經常</label>
                                        </li>
                                        <li class="answer">
                                            <input type='radio' value='5' class='q3' id='q73' name="q7" v-model='q7'>
                                            <label for='q73'>偶爾</label>
                                        </li>
                                        <li class="answer">
                                            <input type='radio' value='2' class='q4' id='q74' name="q7" v-model='q7'>
                                            <label for='q74'>很少</label>
                                        </li>
                                        <li class="answer">
                                            <input type='radio' value='0' class='q5' id='q75' name="q7" v-model='q7'>
                                            <label for='q75'>從不</label>
                                        </li>
                                    </ul>
                                </li>
                                <li class="question">	
                                    <h5>8.反駁的話一說出口就後悔了，我不應該頂撞家長。</h5>
                                    <ul class="option">
                                        <li class="answer">
                                            <input type='radio' value='11' class='q1' id='q81' name="q8" v-model='q8'>
                                            <label for='q81'>總是</label>
                                        </li>
                                        <li class="answer">
                                            <input type='radio' value='8' class='q2' id='q82' name="q8" v-model='q8'>
                                            <label for='q82'>經常</label>
                                        </li>
                                        <li class="answer">
                                            <input type='radio' value='5' class='q3' id='q83' name="q8" v-model='q8'>
                                            <label for='q83'>偶爾</label>
                                        </li>
                                        <li class="answer">
                                            <input type='radio' value='2' class='q4' id='q84' name="q8" v-model='q8'>
                                            <label for='q84'>很少</label>
                                        </li>
                                        <li class="answer">
                                            <input type='radio' value='0' class='q5' id='q85' name="q8" v-model='q8'>
                                            <label for='q85'>從不</label>
                                        </li>
                                    </ul>
                                </li>
                                    <li class="question">	
                                    <h5>9.如果家長因為我決定不考研究所而生氣，是我不聽話造成的。</h5>
                                    <ul class="option">
                                        <li class="answer">
                                            <input type='radio' value='11' class='q1' id='q91' name="q9" v-model='q9'>
                                            <label for='q91'>總是</label>
                                        </li>
                                        <li class="answer">
                                            <input type='radio' value='8' class='q2' id='q92' name="q9" v-model='q9'>
                                            <label for='q92'>經常</label>
                                        </li>
                                        <li class="answer">
                                            <input type='radio' value='5' class='q3' id='q93' name="q9" v-model='q9'>
                                            <label for='q93'>偶爾</label>
                                        </li>
                                        <li class="answer">
                                            <input type='radio' value='2' class='q4' id='q94' name="q9" v-model='q9'>
                                            <label for='q94'>很少</label>
                                        </li>
                                        <li class="answer">
                                            <input type='radio' value='0' class='q5' id='q95' name="q9" v-model='q9'>
                                            <label for='q95'>從不</label>
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                            <div>
                                <div class="btn" @click.prevent="coreCount()">看結果</div>
                            </div>
                        </div>
                        <div v-show="step === 2" id="form_part2">
                            <div class="container center">
                                <div class="col-lg-8">
                                    <div class="container">
                                        <div class="row">
                                            <div class="col-lg-6">
                                                <img id="highimg">
                                            </div>
                                            <div class="col-lg-6">
                                                <h5 id="dectext"></h5>
                                                <!-- <div class="btn"><router-link to="#f6">我想解決被情緒勒索的問題</router-link></div> -->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="container">
                                <h4>測測其他關係：</h4>
                                <div class="row">
                                    <div class="col-lg-4 col-md-4 col-sm-12">
                                        <div class="icon-h center">
                                            <img class="friend" src="static/icon/friend.png">
                                        </div>
                                        <router-link to="/detection/friend" class="btn m10">友情</router-link>
                                    </div>
                                    <div class="col-lg-4 col-md-4 col-sm-12">
                                        <div class="icon-h center">
                                            <img class="love" src="static/icon/love.png">
                                        </div>
                                        <router-link to="/detection/love" class="btn m10">愛情</router-link>
                                    </div>
                                    <div class="col-lg-4 col-md-4 col-sm-12">
                                        <div class="icon-h center">
                                            <img class="work" src="static/icon/work.png">
                                        </div>
                                        <router-link to="/detection/work" class="btn m10">職場</router-link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import axios from "axios";
export default({
    name: 'detectionfamily',
    data() {
        return {
            detections: [],
            options: [],
            step:1,
        }
    },
    mounted() {
        this.getDataDet();
        this.getDataOpt();
    },
    methods: {
        getDataDet() {
            axios.get('static/familydetections.json').then(response => {
                this.detections=response.data.detections
                console.log(response.data);
            }, response => {
                console.log("error");
            });
            
        },
        getDataOpt() {
            axios.get('static/options.json').then(response => {
                this.options=response.data.options
                console.log(response.data);
            }, response => {
                console.log("error");
            });
            
        },
        prev() {
            this.step--;
        },
        next() {
            console.log('dd');
            this.step++
            
        },
        coreCount(){
            this.step++
            var cores=0;
            var qestions=document.getElementsByClassName("question")
            for(var i=0;i<qestions.length;i++)
            {
                var count=0;
                var flag=1;
                var answer=document.getElementsByName("q"+(i+1));
                for(var j=0;j<answer.length;j++)
                {
                    if(answer[j].checked)
                    {
                        count+=answer[j].value*1;
                        console.log(count)
                    }
                }
                if(flag==1)
                    cores+=count;
                    console.log(cores);
                if(cores >= 76){
                    document.getElementById('dectext').innerHTML='糟糕，你被情緒勒索的程度很高喔！情緒勒索的戲碼一而再再而三地重複上演，你必須開始思考自己在關係中的定位以及如何讓自己更開心，並努力嘗試改善關係狀態喔～';
                    document.getElementById('highimg').src='static/高.png';
                }else if(cores >= 51 && cores <= 75){
                    document.getElementById('dectext').innerHTML='哎呀，你被情緒勒索的程度介於中間！你很容易受到各種方式的情緒勒索。建議你隨時注意、觀察自己的狀態，以避免深陷於勒索的情況喔～';
                    document.getElementById('highimg').src='static/中.png';
                }else if(cores >= 26 && cores <= 50){
                    document.getElementById('dectext').innerHTML='耶嘿，你被情緒勒索的程度很低喔！你可能經歷過幾段被勒索的關係，但似乎成功逃離了呢～';
                    document.getElementById('highimg').src='static/輕.png';
                }else if(cores < 25){
                    document.getElementById('dectext').innerHTML='恭喜你，你沒有被情緒勒索困擾喔！你不是容易被欺負的對象，你所處的關係中幾乎沒有情緒勒索的出現～';
                    document.getElementById('highimg').src='static/健康.png';
                }  
            }	
        }
    },
})



</script>

<style>

form{
	margin-top: 20px ;
	list-style: none;
	border-radius: 5px;
    background-color: #fff;
    padding: 20px;
}
.question{
    padding: 10px;
    text-align: left;
    background-color:rgba(229,222,165,0.1);
    border-radius: 5px;
    margin-bottom: 20px;
    margin-right: 40px;
}


.answer{
    display: inline-block;
    margin-top: 10px;
}

form h2{
    font-size: 30px;
}

.btn{
    margin: 10px 20px 10px 20px;
}

#highimg{
    width: 70%;
}


#form_part2 h4{
    text-align: left;
    padding: 10px;
    margin-top: 20px;
}


h5#dectext{
    text-align: left;
    line-height: 1.5;
}

input[type=radio]{
    visibility:hidden;
}

label {
    background-color:rgba(229,222,165,0.25);
    position:relative;
    display: inline-block;
    border-radius: 5px;
    cursor: pointer;
    z-index: 1;
    padding: 10px 25px;
    margin-right: 10px;
    margin-bottom: 6px;
}

input[type=radio]:checked + label{
    background-color:#EEB868;
    color:#fff;
    padding: 10px 25px;
}

input[type=submit]{
    background-color:#EEB868;
    color:#fff;
    padding: 15px 25px;
    border:none;
    border-radius: 5px;
    margin-top:30px;
    font-weight: bold;
    font-size: 18px;
}

input[type=submit]:hover{
    font-size:20px;
}



</style>


// WEBPACK FOOTER //
// src/components/pages/DetectionFamily.vue